/**
 * Labstep
 */

import { SignatureTypeAction } from 'labstep-web/components/Signature/constants';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type { Group } from 'labstep-web/models/group.model';
import type { SignatureRequirement } from 'labstep-web/models/signature-requirement.model';

export const getDefaultStatement = (
  signatureTypeAction: SignatureTypeAction,
  signatureRequirement?: SignatureRequirement | null,
  activeGroup?: Group | null,
) => {
  if (signatureTypeAction === SignatureTypeAction.reject) {
    return undefined;
  }
  if (
    signatureRequirement?.statement ??
    activeGroup?.default_signature_statement
  ) {
    return (
      signatureRequirement?.statement ??
      activeGroup?.default_signature_statement
    );
  }
  return `I hereby confirm that I have read and approve the ${ExperimentWorkflow.getHumanReadableEntityName()}.`;
};
